// MODULAR PROFILE ELMO IDS
export const MODULAR_PROFILE_PRODUCTION_EXPERIMENT_ID = '111435' as const
export const MODULAR_PROFILE_PRODUCTION_TREATMENT_ID = '157496' as const

// CREATE PROFILE ELMO IDS
export const CREATE_PROFILE_PRODUCTION_EXPERIMENT_ID = '109914' as const
export const CREATE_PROFILE_PRODUCTION_TREATMENT_ID = '147927' as const
